/* eslint-disable react-native/no-inline-styles */
import React, { useEffect } from 'react';
import { View, StyleSheet, ActivityIndicator } from 'react-native';
import { useSelector, useDispatch } from 'react-redux';
import Colors from '~global/Colors';
import { isWeb } from '~global/screens';

const Modal = React.lazy(() => import('@web-components/common/Modal'));

const ModalLoading = () => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.modal.loading.isShow);
  const onClose = () => dispatch({ type: 'MODAL/HIDE', modalName: 'loading' });

  useEffect(() => {
    if (!loading) {
      onClose();
    }
  }, [loading]);

  return (
    <Modal transparent isVisible={loading} animationType="fade">
      <View style={styles.overlay}>
        <View style={styles.modalContainer}>
          <ActivityIndicator size="large" color={Colors.purple0} />
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    backgroundColor: Colors.white,
    borderRadius: isWeb ? 10 : 8,
    padding: 20,
    alignItems: 'center',
    justifyContent: 'center',
    width: isWeb ? 100 : 60,
    height: isWeb ? 100 : 60,
  },
});

export default ModalLoading;
